import { render, staticRenderFns } from "./orderDialog.vue?vue&type=template&id=2e16deae&scoped=true&"
import script from "./orderDialog.vue?vue&type=script&lang=js&"
export * from "./orderDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderDialog.vue?vue&type=style&index=0&id=2e16deae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e16deae",
  null
  
)

export default component.exports